import { css } from '@emotion/react';

export const large = css`
  height: 32px;
  padding: 4px 18px;

  font-size: 1rem;
`;
export const medium = css`
  height: 24px;
  padding: 4px 15px;

  font-size: 0.688rem;
`;
export const small = css`
  height: 18px;
  padding: 4px 8px;

  font-size: 0.438rem;
`;
